import { render, staticRenderFns } from "./CustomInputRta.vue?vue&type=template&id=f3148ada&scoped=true&"
import script from "./CustomInputRta.vue?vue&type=script&lang=js&"
export * from "./CustomInputRta.vue?vue&type=script&lang=js&"
import style0 from "./CustomInputRta.vue?vue&type=style&index=0&id=f3148ada&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3148ada",
  null
  
)

export default component.exports